import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Zap, Flame, AlertCircle } from 'lucide-react';
import { Button } from './Button';
const included = [{
  text: 'Ebook Central',
  bold: 'Palomitas Gourmet'
}, {
  text: '+30 Recetas Estrella',
  bold: '(Oreo, Kinder, Nido y más)'
}, {
  text: '7 Bonos de Negocios',
  bold: 'Adicionales'
}, {
  text: 'Módulo Premium:',
  bold: 'Ventas en Gran Volumen'
}, {
  text: 'Acceso',
  bold: 'De Por Vida + Actualizaciones'
}];
function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 8,
    minutes: 10,
    seconds: 42
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex justify-center gap-4" data-id="element-144">
      {[{
      value: pad(0),
      label: 'DÍAS'
    }, {
      value: pad(time.hours),
      label: 'HORAS'
    }, {
      value: pad(time.minutes),
      label: 'MIN'
    }, {
      value: pad(time.seconds),
      label: 'SEG'
    }].map((item, i) => <div key={i} className="flex flex-col items-center" data-id="element-145">
          <div className="border-2 border-palomitas-emerald rounded-lg w-16 h-16 md:w-20 md:h-20 flex items-center justify-center" data-id="element-146">
            <span className="text-2xl md:text-4xl font-bold text-white" data-id="element-147">
              {item.value}
            </span>
          </div>
          <span className="text-xs text-gray-400 mt-1 font-medium" data-id="element-148">
            {item.label}
          </span>
        </div>)}
    </div>;
}
export function Offer() {
  return <section id="oferta" className="py-16 bg-[#1a1f2e]" data-id="element-149">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-150">
        {/* Title Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-151">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-3" data-id="element-152">
            Tu Negocio "Llave en Mano"
          </h2>
          <div className="w-16 h-1 bg-palomitas-emerald mx-auto mb-5" data-id="element-153"></div>
          <p className="text-lg text-gray-300" data-id="element-154">
            Todo lo que necesitás para facturar esta misma semana. Un solo pago,
            acceso de por vida.
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-155">
          <img src="https://cdn.magicpatterns.com/uploads/5BGwFqHujaHQwrAS4M9kKg/ChatGPT_Image_30_abr_2026,_17_45_21.png" alt="Palomitas Gourmet - Programa Completo" className="w-full rounded-2xl shadow-2xl" data-id="element-156" />
        </motion.div>

        {/* Price Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-lg mx-auto border-2 border-palomitas-gold rounded-2xl p-8 text-center mb-6" style={{
        boxShadow: '0 0 30px rgba(201, 168, 76, 0.3), 0 0 60px rgba(201, 168, 76, 0.15)'
      }} data-id="element-157">
          <p className="text-gray-400 line-through text-lg mb-1" data-id="element-158">$89.900 ARS</p>
          <div className="flex justify-center items-baseline gap-1 mb-4" data-id="element-159">
            <span className="text-yellow-400 text-lg" data-id="element-160">💰</span>
            <span className="text-5xl md:text-7xl font-bold text-palomitas-gold" data-id="element-161">
              $9.900
            </span>
            <span className="text-2xl text-palomitas-gold font-bold" data-id="element-162">ARS</span>
          </div>

          <div className="inline-block bg-palomitas-gold/20 border border-palomitas-gold rounded-full px-6 py-2 mb-5" data-id="element-163">
            <span className="font-bold text-palomitas-gold text-lg" data-id="element-164">
              AHORRÁ $80.000 (89% OFF)
            </span>
          </div>

          <div className="flex justify-center gap-8 text-gray-300" data-id="element-165">
            <div className="flex items-center gap-2" data-id="element-166">
              <ShieldCheck size={20} className="text-palomitas-gold" data-id="element-167" />
              <div className="text-sm" data-id="element-168">
                <p className="font-bold" data-id="element-169">Pago</p>
                <p data-id="element-170">Seguro</p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-171">
              <Zap size={20} className="text-palomitas-gold" data-id="element-172" />
              <div className="text-sm" data-id="element-173">
                <p className="font-bold" data-id="element-174">Entrega</p>
                <p data-id="element-175">Inmediata</p>
              </div>
            </div>
          </div>

          {/* What's Included */}
          <div className="border border-gray-600 rounded-xl p-6 mt-6 text-left" data-id="element-176">
            {included.map((item, index) => <div key={index} className="flex items-start gap-3 mb-4 last:mb-0" data-id="element-177">
                <CheckCircle2 className="text-palomitas-emerald flex-shrink-0 mt-0.5" size={20} data-id="element-178" />
                <p className="text-gray-300" data-id="element-179">
                  {item.text}{' '}
                  <strong className="text-white" data-id="element-180">{item.bold}</strong>
                </p>
              </div>)}
          </div>
        </motion.div>

        {/* Countdown Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-lg mx-auto bg-[#252a3a] rounded-2xl p-8 text-center mb-8" style={{
        boxShadow: '0 0 25px rgba(52, 211, 153, 0.15)'
      }} data-id="element-181">
          <p className="text-lg font-bold text-white mb-2 flex items-center justify-center gap-2" data-id="element-182">
            🚨 <span data-id="element-183">OFERTA FLASH LIMITADA</span>
          </p>
          <p className="text-gray-400 mb-6 text-sm" data-id="element-184">
            El precio promocional y los 7 bonos de regalo expiran cuando el
            contador llegue a cero.
          </p>
          <CountdownTimer data-id="element-185" />
          <div className="mt-6" data-id="element-186">
            <Button href="https://cocinaydulcesrentables.com/cart/54079623528732:1" className="!bg-[#6b7a3d] hover:!bg-[#7d8e4a] !text-white text-lg px-8 py-4" data-id="element-187">
              ¡ES TU MOMENTO!
            </Button>
          </div>
        </motion.div>

        {/* CTA Buttons */}
        <div className="space-y-4 mb-6" data-id="element-188">
          <motion.div animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-189">
            <Button href="https://cocinaydulcesrentables.com/cart/54079623528732:1" className="w-full text-lg md:text-xl py-5 !bg-[#4CAF50] hover:!bg-[#43A047] !text-white shadow-xl shadow-green-500/30 rounded-2xl" data-id="element-190">
              ¡QUIERO ACCEDER AL SISTEMA COMPLETO YA!
            </Button>
          </motion.div>

          <motion.div animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.3
        }} data-id="element-191">
            <div className="bg-[#424750] rounded-2xl py-4 px-6 text-center" data-id="element-192">
              <p className="text-white font-bold flex items-center justify-center gap-2" data-id="element-193">
                <Flame size={20} className="text-orange-400" data-id="element-194" />
                🔥 569 personas están aprovechando esta oportunidad.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Price Warning */}
        <div className="text-center mb-4" data-id="element-195">
          <p className="text-yellow-300 font-bold text-lg flex items-center justify-center gap-2 drop-shadow-[0_0_10px_rgba(253,224,71,0.5)]" data-id="element-196">
            <motion.span animate={{
            scale: [1, 1.3, 1],
            rotate: [0, -10, 10, 0]
          }} transition={{
            duration: 0.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-block" data-id="element-197">
              🔥
            </motion.span>
            EL PRECIO AUMENTARÁ EN BREVE
          </p>
        </div>

        {/* Urgency Button */}
        <motion.div animate={{
        scale: [1, 1.02, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mb-10" data-id="element-198">
          <Button href="https://cocinaydulcesrentables.com/cart/54079623528732:1" className="w-full text-lg md:text-xl py-5 !bg-[#E8553A] hover:!bg-[#D44A32] !text-white shadow-xl shadow-red-500/30 rounded-2xl" data-id="element-199">
            <AlertCircle size={20} className="mr-2" data-id="element-200" />
            ÚLTIMOS 3 CUPOS CON PRECIO CONGELADO
          </Button>
        </motion.div>

        {/* Payment Methods */}
        <div className="flex justify-center mb-4" data-id="element-201">
          <img src="https://cdn.magicpatterns.com/uploads/fkh8cE83ij2Pnr6kUneft6/Captura_de_pantalla_2026-05-01_a_las_1.00.55_a._m..png" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, Mercado Pago" className="max-w-md w-full rounded-2xl" data-id="element-202" />
        </div>

        {/* MercadoLíder Platinum */}
        <div className="flex justify-center" data-id="element-203">
          <img src="https://cdn.magicpatterns.com/uploads/mw1P415nFeFgWvxJbucDhN/Captura_de_pantalla_2026-05-01_a_las_1.17.24_a._m..png" alt="MercadoLíder Platinum - 145121 ventas, brinda buena atención, despacha a tiempo" className="max-w-md w-full rounded-2xl" data-id="element-204" />
        </div>
      </div>
    </section>;
}